import script from "./DashboardSDAA.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardSDAA.vue?vue&type=script&setup=true&lang=js"

import "./DashboardSDAA.vue?vue&type=style&index=0&id=2011c990&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2011c990"]])

export default __exports__